import MissionIcon from '@/assets/icons/missions-menu-item.svg?react'
import { Text } from '@/ui-kit'
import { Trans } from '@lingui/react/macro'

export const MissionHeader = ({ title }: { title?: React.ReactNode }) => {
  return (
    <div className="flex flex-wrap items-center justify-between gap-4">
      {title ? (
        title
      ) : (
        <Text type="h4">
          <Trans>Missions</Trans>
        </Text>
      )}
      <div className="flex max-w-[720px] items-center gap-5 rounded-lg border border-solid border-gray-100 px-5 py-3">
        <MissionIcon className="text-green shrink-0" />
        <div className="text-gray-80 text-body-2 text-wrap">
          <Trans>Complete the missions below to earn more $DATA points and real USD rewards.</Trans>
        </div>
      </div>
      <div className="w-[123px]" />
    </div>
  )
}
